module.exports = __webpack_public_path__ + "static/media/ic_duplicate.05247da7.svg";